import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./History.module.css";
import apiService from "../../services/api";

gsap.registerPlugin(ScrollTrigger);

function History() {
    const [historyData, setHistoryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const itemRefs = useRef([]);
    itemRefs.current = [];

    // 연혁 데이터 가져오기
    const fetchHistoryData = async () => {
        setLoading(true);
        setError(null);
        
        try {
            const response = await apiService.getHistory(1, 1000);
            const histories = response.histories || response || [];
            
            // 각 연혁 항목을 개별적으로 처리 (연도별 그룹화 제거)
            const processedData = histories
                .filter(history => history.isActive !== false) // 활성화된 연혁만 (isActive가 false가 아닌 것)
                .sort((a, b) => {
                    // 연도 내림차순으로 정렬
                    return parseInt(b.year) - parseInt(a.year);
                })
                .map(history => ({
                    id: history.id,
                    year: history.year,
                    title: history.title,
                    description: history.description || '',
                    // 설명을 줄바꿈으로 분리하여 배열로 변환
                    lines: history.description ? history.description.split('\n').filter(line => line.trim()) : []
                }));

            setHistoryData(processedData);
        } catch (error) {
            console.error('연혁 데이터 가져오기 실패:', error);
            setError('연혁 데이터를 불러오는데 실패했습니다.');
            setHistoryData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchHistoryData();
    }, []);
    useEffect(() => {
        const items = itemRefs.current.filter((el) => el);

        items.forEach((item) => {
            gsap.fromTo(
                item,
                {
                    autoAlpha: 0,
                    y: 50, // 아래에서 시작
                },
                {
                    autoAlpha: 1,
                    y: 0, // 원래 위치로
                    duration: 0.8,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 85%",
                        toggleActions: "play none none reverse",
                    },
                }
            );
        });

        return () => {
            ScrollTrigger.getAll().forEach((t) => t.kill());
        };
    }, [historyData]);

    const addToRefs = (el) => {
        if (el && !itemRefs.current.includes(el)) {
            itemRefs.current.push(el);
        }
    };

    if (loading) {
        return (
            <div className={styles.timelineWrap}>
                <div className={styles.loading}>연혁 데이터를 불러오는 중...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.timelineWrap}>
                <div className={styles.error}>{error}</div>
            </div>
        );
    }

    if (historyData.length === 0) {
        return (
            <div className={styles.timelineWrap}>
                <div className={styles.empty}>등록된 연혁이 없습니다.</div>
            </div>
        );
    }

    return (
        <div className={styles.timelineWrap}>
            <div className={styles.timeline}>
                {historyData.map((item, idx) => (
                    <div
                        className={`${styles.timelineItem} ${
                            idx % 2 === 0 ? styles.left : styles.right
                        }`}
                        key={idx}
                        ref={addToRefs}
                    >
                        <div className={styles.year}></div>
                        <div className={styles.content}>
                            <div className={styles.yeartext}>
                                {item.year}
                            </div>
                            <ul>
                                {item.lines.map((txt, i) => (
                                    <li key={i}>
                                        <span>{txt}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
                <div className={styles.centerLine}></div>
            </div>
        </div>
    );
}
export default History;